import { render } from "./integrationsRequiredFields.vue?vue&type=template&id=6f12888b&scoped=true"
import script from "./integrationsRequiredFields.vue?vue&type=script&lang=js"
export * from "./integrationsRequiredFields.vue?vue&type=script&lang=js"

import "./integrationsRequiredFields.vue?vue&type=style&index=0&id=6f12888b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f12888b"]])

export default __exports__